import React from 'react';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import FullScreen from '@/components/FullScreen';
import LayerSwitcherCtrl from '@/components/LayerSwitcher/LayerSwitcherCtrl';
import MeasuresCtrl from '@/components/Measures/MeasuresCtrl';
import SearchControlCtrl from '@/components/SearchLocation/SearchLocationCtrl';
import Zoom from '@/components/Zoom';
import styles from './Toolbars.module.scss';

export default function Left({ map }) {
  return (
    <Stack spacing={2} className={styles.leftToolbar}>
      <SearchControlCtrl map={map} />
      <Zoom map={map} />
      <FullScreen map={map} />
      <LayerSwitcherCtrl />
      <MeasuresCtrl map={map} />
    </Stack>
  );
}

Left.propTypes = {
  map: PropTypes.object.isRequired,
};
